<a [routerLink]="[affiliateAgreementRoute]">{{ 'menu.affiliateAgreement' | translate }}</a>

<cab-social-links [size]="isDesktopMode ? 'l' : 's'" />

<a [routerLink]="[privacyPolicyRoute]">{{ 'menu.privacyPolicy' | translate }}</a>
